import { combineReducers } from "redux";

import auth from "./auth";
import students from "./students";

export const reducers = combineReducers({ auth, students });
